// One callback ref that sets several refs: a component's own (useRef) and the one its parent passes as `ref`.
import type { Ref } from "react";

export const mergeRefs =
  <T>(...refs: (Ref<T> | undefined)[]) =>
  (el: T | null) => {
    for (const ref of refs) {
      if (typeof ref === "function") ref(el);
      else if (ref) ref.current = el;
    }
  };
